module.exports = __webpack_public_path__ + "media/V100.33c0f8bd.mp4";